/** @description always include jQuery in this manner in every file where jQuery is used */
const $ = jQuery.noConflict();

'use strict';
const PopupToggle = {
	$domBody: $('.js-body'),
	$domChatBox: $('.js-comp-chat'),
	$domOpenChat: $('.js-open-chat'),
	$domCloseChat: $('.js-close-chat'),
	$domSuggBox: $('.js-sugg-popup'),
	$domOpenSugg: $('.js-sugg-popup-open'),
	$domCloseSugg: $('.js-sugg-popup-close'),
	$domMustSubscribeMsg: $('.js-must-subscribe-msg'),
	classActive: 'is-active',
	classLocked: 'is-locked',
	classMustSub: 'js-must-subscribe',

	/**
	 * @description Initialize
	 */
	init: function() {
		this.bindEvents();
	},

	bindEvents: function() {
		this.$domOpenChat.on('click', this.showChat);
		this.$domCloseChat.on('click', this.closeChat);
		this.$domOpenSugg.on('click', this.showSuggBox);
		this.$domCloseSugg.on('click', this.closeSuggBox);
	},

	showChat: function() {
		PopupToggle.$domChatBox.addClass(PopupToggle.classActive);
		PopupToggle.$domBody.addClass(PopupToggle.classLocked);
	},

	closeChat: function() {
		PopupToggle.$domChatBox.removeClass(PopupToggle.classActive);
		PopupToggle.$domBody.removeClass(PopupToggle.classLocked);
	},

	showSuggBox: function() {
		if (!$(this).hasClass(PopupToggle.classMustSub)) {
			PopupToggle.$domSuggBox.addClass(PopupToggle.classActive);
			PopupToggle.$domBody.addClass(PopupToggle.classLocked);
		} else {
			window.location.href = window.origin + '/login';
		}
	},

	closeSuggBox: function() {
		PopupToggle.$domSuggBox.removeClass(PopupToggle.classActive);
		PopupToggle.$domBody.removeClass(PopupToggle.classLocked);
	}
};

export default PopupToggle;
